<ng-container>
  @if (data.emptyState.empty) {
    <div class="vertical-container-simple column-gap-1">
      <!--  HEADER    -->
      <div class="space-between-horizontal-centered height-1p25">
        <span [attr.data-qa]="'pie-chart-title'+ data.title" class="font-2 bold600">{{data.title}}</span>
        <app-button *ngIf="isAdmin" [size]="'small'" [iconName]="'edit-outline.svg'" (buttonClick)="editClicked.emit()">Edit</app-button>
      </div>

      <!--  EMPTY-BODY      -->
      <div class="space-between-horizontal">
        <div class="start-column-vertically-centered-container column-gap-0p75">
          <span [attr.data-qa]="'pie-chart-empty-title'+ data.title" class="font-2 bold600 opacity0p64">{{data.emptyState.title}}</span>
          <span [attr.data-qa]="'pie-chart-empty-subtitle'+ data.title" class="font-3 opacity0p64">{{data.emptyState.subtitle}}</span>
        </div>
        <div [attr.data-qa]="'pie-chart-empty-pie'+ data.title" #pie class="centered-vertically-column-container pie bg-black-4">
          <div class="hole">
          </div>
        </div>
      </div>
    </div>
  }

  @else {
    <div class="vertical-container-simple column-gap-1">

      <!--  HEADER    -->
      <div class="space-between-horizontal-centered height-1p25">
        <div class="centered-row-container-flex-start row-gap-0p25">
          <span [attr.data-qa]="'pie-chart-title'+ data.title" class="font-2 bold600">{{data.title}}</span>
          <span *ngIf="data.mainValue" [attr.data-qa]="'pie-chart-main-value'+ data.title" class="font-4 bold500 black-10 bg-black-3 br-1 padding-0p15625-0p3125">{{data.mainValue}}</span>
        </div>
        <app-button *ngIf="isAdmin" [size]="'small'" [iconName]="'edit-outline.svg'" (buttonClick)="editClicked.emit()">Edit</app-button>
      </div>


      <div class="space-between-horizontal">

        <!-- FIN DATA -->
        <div class="start-column-container column-gap-0p75 pd-top-1p25">
          <ng-container *ngFor="let finData of data.finData; let i = index" >
            <div class="centered-row-container row-gap-0p25">
              <div [attr.data-qa]="'pie-chart-color-dot-'+ data.title + i" class="dot" [style.background]="finData.color"></div>
              <span [attr.data-qa]="'pie-chart-name-'+ data.title + i" class="font-3">{{ finData.name }}</span>
              <div class="centered-row-container-flex-start row-gap-0p5 bg-black-3 br-1 padding-0p15625-0p3125">
                <span [attr.data-qa]="'pie-chart-value-'+ data.title + i" class="font-4 bold500 black-10">{{finData.value | dashInsteadOfNull}}</span>
                <span *ngIf="finData.pcnt !== '-'" [attr.data-qa]="'pie-chart-pcnt-'+ data.title + i" class="font-4 bold400 opacity0p72">{{finData.pcnt}}</span>
              </div>
            </div>
          </ng-container>
          <ng-container  *ngIf="data.aboveCommitment && data.aboveCommitment.value">
            <div class="start-column-container column-gap-0p75">
              <div class="grey-line width-20"></div>
              <div class="start-row-container row-gap-0p25">
                <span [attr.data-qa]="'pie-chart-above-comm-'+ data.title" class="font-3 pd-l-1p1">{{ data.aboveCommitment.name }}</span>
                <div class="centered-row-container-flex-start row-gap-0p5 bg-black-3 br-1 padding-0p15625-0p3125">
                  <span [attr.data-qa]="'pie-chart-above-comm-value-'+ data.title" class="font-4 bold500 black-10">{{data.aboveCommitment.value}}</span>
                  <span [attr.data-qa]="'pie-chart-above-comm-pcnt-'+ data.title" class="font-4 bold400 opacity0p72">{{data.aboveCommitment.pcnt}}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- CHART -->
        <div #pie [attr.data-qa]="'pie-chart-pie'+ data.title" [style]="data.pieStyle" class="centered-vertically-column-container pie">
          <div class="hole">
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>
